import { render, staticRenderFns } from "./StockUpdate.vue?vue&type=template&id=62baf3c4&scoped=true&"
import script from "./StockUpdate.vue?vue&type=script&lang=js&"
export * from "./StockUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62baf3c4",
  null
  
)

export default component.exports